"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_modules_promotions_1 = require("@saatva-bits/pattern-library.modules.promotions");
const pattern_library_components_dropdown_1 = require("@saatva-bits/pattern-library.components.dropdown");
const selection_hooks_1 = require("../../../../selection.hooks");
const selection_utils_1 = require("../../../../selection.utils");
const ProductLabel_1 = __importDefault(require("../ProductLabel/ProductLabel"));
const DropdownPriceDisplay_1 = __importDefault(require("../DropdownPriceDisplay"));
const ProductSelectDropdown_module_scss_1 = __importDefault(require("./ProductSelectDropdown.module.scss"));
/**
 *
 * @param {Object} props
 * @param {string} props.productCode
 * @param {string} props.attributeCode
 * @param {boolean} props.displayPrice
 * @param {string} props.className
 * @param {Object.<string, string>} props.toggleProps
 * @param {string} props.dataSelector
 * @param {boolean} props.canScroll
 * @param {boolean} props.isOutOfStockStyling
 * @returns {import('react').ReactNode}
 */
const ProductSelectDropdown = ({ productCode, attributeCode, displayPrice, className, toggleProps, dataSelector, canScroll = false, isOutOfStockStyling }) => {
    const options = (0, selection_hooks_1.useAttributeOptions)(productCode, attributeCode);
    const productData = (0, selection_hooks_1.useProductData)(productCode);
    const { surplusDiscountDefinitions } = (0, pattern_library_modules_promotions_1.usePromotionsData)();
    const optionElements = options && options.values.map((value) => {
        let labelClasses = '';
        if (isOutOfStockStyling) {
            // This option is considered "out of stock" if all variants with this attribute value are out of stock
            const variantsForAttributeValue = (0, selection_utils_1.findVariantsWithAttributeValue)(productData, options.code, value.code);
            const isInStock = variantsForAttributeValue === null || variantsForAttributeValue === void 0 ? void 0 : variantsForAttributeValue.find(variant => variant.inStock);
            labelClasses = (0, classnames_1.default)({
                [ProductSelectDropdown_module_scss_1.default['dropdown-outOfStock']]: !isInStock
            });
        }
        const itemText = displayPrice ? ((0, jsx_runtime_1.jsxs)("div", { className: `${ProductSelectDropdown_module_scss_1.default['dropdown-item']} u-flexDisplay u-flexJustify--spaceBetween`, children: [(0, jsx_runtime_1.jsx)("span", { className: labelClasses, children: value.label }), (0, jsx_runtime_1.jsx)(DropdownPriceDisplay_1.default, { productCode: productCode, updatedAttributes: { [attributeCode]: value.code } })] })) : (0, jsx_runtime_1.jsx)("span", { className: labelClasses, children: value.label });
        return {
            text: itemText,
            value: value.code
        };
    });
    const onChange = (selectedItem) => {
        options.setAttributeValue(selectedItem.value);
    };
    const showSurplusSaleLabel = (0, react_1.useMemo)(() => {
        return displayPrice && productData && productData.variants.some(variant => surplusDiscountDefinitions[variant.sku] > 0);
    }, [productCode, displayPrice]);
    if (!options)
        return null; // Make sure this is after all hooks to avoid React errors
    const labelText = attributeCode === 'quantity' ? options.displayName : `Select ${options.displayName.toLowerCase()}`;
    return ((0, jsx_runtime_1.jsxs)("div", { "data-selector": dataSelector, className: className, children: [(0, jsx_runtime_1.jsx)(ProductLabel_1.default, { index: 0, label: labelText, isCustomLabel: true, hideQuantity: true, hideSize: false, isCheckbox: false, showSurplusSaleLabel: showSurplusSaleLabel, modalContentProps: { productCode, sku: productCode }, ...toggleProps }), (0, jsx_runtime_1.jsx)(pattern_library_components_dropdown_1.Dropdown, { canScroll: canScroll, disabledItems: [false], defaultText: `Select ${options.displayName}`, textClassName: `${ProductSelectDropdown_module_scss_1.default['dropdown-text']} ${ProductSelectDropdown_module_scss_1.default[`${attributeCode}Select-text`]}`, listClassName: `${canScroll ? ProductSelectDropdown_module_scss_1.default['dropdown-list'] : ProductSelectDropdown_module_scss_1.default['dropdown-full-height']}`, selectedValue: options.selectedValue, itemsData: optionElements, onChange: onChange, id: attributeCode })] }));
};
ProductSelectDropdown.propTypes = {
    productCode: prop_types_1.default.string.isRequired,
    attributeCode: prop_types_1.default.string.isRequired,
    dataSelector: prop_types_1.default.string.isRequired,
    displayPrice: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    toggleProps: prop_types_1.default.object,
    canScroll: prop_types_1.default.bool,
    isOutOfStockStyling: prop_types_1.default.bool
};
exports.default = (0, react_1.memo)(ProductSelectDropdown);
//# sourceMappingURL=ProductSelectDropdown.js.map